import VIDABOO_CONSTANTS from '../config/consts';
import {ShoutingRoomService} from './websocketService';

////////////////////// Service Template Head  /////////////////////////

let privateState = {}; // private variables for this service.
let service = {};

////////////////////// End Service Template Head  /////////////////////////

privateState.peerUserIdsHash = {};
privateState.deleteDoWhenMessageReceivedFromShoutingRoom = {};
privateState.availabilityCallbackFunctions = {};

// const functionsHash = privateState.availabilityCallbackFunctions;
// if (functionsHash !== undefined && functionsHash !== null) {
//   Object.values(functionsHash).forEach(func => {
//     func(privateState.myAvailability);
//   });
// }

privateState.registerListenersForPeerUserId = (peerUserId) => {
  //   if (privateState.peerUserIdsHash[peerUserId]) return;
  if (!privateState.deleteDoWhenMessageReceivedFromShoutingRoom[peerUserId]) {
    privateState.deleteDoWhenMessageReceivedFromShoutingRoom[peerUserId] =
      ShoutingRoomService.doWhenMessageReceivedFromShoutingRoom(
        peerUserId,
        privateState.doWhenMessageReceivedFromShoutingRoom,
      );
  }
  if (!privateState.deleteDoWhenMessageReceivedFromShoutingRoomServer) {
    privateState.deleteDoWhenMessageReceivedFromShoutingRoomServer =
      ShoutingRoomService.doWhenMessageReceivedFromShoutingRoom(
        'server', // sometimes server sends availability states
        privateState.doWhenMessageReceivedFromShoutingRoom,
      );
  }
};
privateState.deleteAllListeners = () => {
  Object.keys(privateState.peerUserIdsHash) &&
    Object.keys(privateState.peerUserIdsHash).forEach((peerUserId) => {
      this.deleteListeners(peerUserId);
    });
};
privateState.deleteListeners = (peerUserId) => {
  privateState.deleteDoWhenMessageReceivedFromShoutingRoom[peerUserId]();
  delete privateState.deleteDoWhenMessageReceivedFromShoutingRoom[peerUserId];
  privateState.deleteDoWhenMessageReceivedFromShoutingRoomServer();
  privateState.deleteDoWhenMessageReceivedFromShoutingRoomServer = null;
  //   delete privateState.availabilityCallbackFunctions[peerUserId];
};

privateState.doWhenMessageReceivedFromShoutingRoom = (data) => {
  // if message is an availability message:
  // if message is from server or one of the peers we're listening to - activate callback function based on the roomId which is equal to the peerUserId
  if (
    data.messageType ===
    VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.AVAILABILITY_STATUS
  ) {
    if (data.senderUserId === 'server') {
      const peerCallbackFunctions =
        privateState.availabilityCallbackFunctions[data.content.roomId];
      peerCallbackFunctions &&
        Object.values(peerCallbackFunctions).forEach((callbackFunc) => {
          callbackFunc(data.content.availabilityState.toLowerCase());
        });
    } else if (
      privateState.deleteDoWhenMessageReceivedFromShoutingRoom.hasOwnProperty(
        data.senderUserId,
      )
    ) {
      console.debug('user status');

      const peerCallbackFunctions =
        privateState.availabilityCallbackFunctions[data.senderUserId];
      peerCallbackFunctions &&
        Object.values(peerCallbackFunctions).forEach((callbackFunc) => {
          callbackFunc(data.content.availabilityState.toLowerCase());
        });
    }
  }
};

service.doWhenAvailabilityStateChanged = (peerUserId, callbackFunction) => {
  // registers a callback function that will be called when availabilityChange of peerUserId.
  privateState.registerListenersForPeerUserId(peerUserId); // registering listeners
  if (!privateState.availabilityCallbackFunctions.hasOwnProperty(peerUserId))
    privateState.availabilityCallbackFunctions[peerUserId] = [];
  const callbackFunctionId =
    new Date().getTime() + '_' + Math.floor(Math.random() * 1e8);
  privateState.availabilityCallbackFunctions[peerUserId][callbackFunctionId] =
    callbackFunction;
  return () => {
    delete privateState.availabilityCallbackFunctions[peerUserId][
      callbackFunctionId
    ];
  };
};

const peerAvailabilityStateService = {...service};
export default peerAvailabilityStateService;
